import React from "react";

import { useForm } from "react-hook-form";

const VitalForm1 = (props) => {
  const { nextStep } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();



  const onSubmit = (data) => {
    const form1 = {
      // age: +data.age,
      height: {
        value: +data?.height,
        unit: "cm",
      },
      weight: {
        value: +data?.weight,
        unit: "kg",
      },
    }
    sessionStorage.setItem('form1',JSON.stringify(form1))
    console.log(form1, "payload");
    nextStep()
  };
const onSkip = () => {
  nextStep()
}
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* <div className="">
          <label
            htmlFor="age"
            className="text-black text-base font-medium font-['SF Pro Display'] pl-1 mb-3"
          >
            Age
          </label>
          <div className="flex">
            <input
              {...register("age", {
                required: 'required',
                max: { value: 120, message: 'Age must be at most 120' },
                min: { value: 0, message: 'Age must be at least 0' },
              })}
              id="age"
              name="age"
              type="number"
              autoComplete="off"
              autoCorrect="off"
              className="w-[110px] bg-gray-200  flex  rounded-lg border border-input  px-3 py-2 mt-2 text-base shadow-sm transition-colors   focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
            />{" "}
            <div className="pl-2 pt-3">years old</div>
          </div>

          {errors.age && (
            <p className="py-2 text-xs text-red-500">{errors.age.message}</p>
          )}
        </div> */}
        <div className="flex sm:flex-row gap-2 my-2">
          <div className="w-full sm:w-4/12 min-w-[100px]">
            <label
              htmlFor="height"
              className="text-black text-base font-medium  font-['SF Pro Display'] pl-3 pb-2"
            >
              Height(cm)
            </label>
            <input
              {...register("height", {
                required: true,
              })}
              id="height"
              name="height"
              type="number"
              step="0.01"
              autoComplete="off"
              autoCorrect="off"
              className=" bg-gray-200  flex h-9 w-full rounded-lg border border-input  px-3 py-2 mt-2 text-base shadow-sm transition-colors   focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
            />
            {errors.height && (
              <p className="py-2 text-xs text-red-500">{"required"}</p>
            )}
          </div>
          <div className="w-full sm:w-4/12 min-w-[100px]">
            <label
              htmlFor="weight"
              className="text-black text-base font-medium  font-['SF Pro Display'] pl-3 pb-2"
            >
              Weight(kg)
            </label>
            <input
              {...register("weight", {
                required: true,
              })}
              id="weight"
              name="weight"
              type="number"
              step="0.01"
              autoComplete="off"
              autoCorrect="off"
              className=" bg-gray-200  flex h-9 w-full rounded-lg border border-input  px-3 py-2 mt-2 text-base shadow-sm transition-colors   focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
            />
            {errors.weight && (
              <p className="py-2 text-xs text-red-500">{"required"}</p>
            )}
          </div>
        </div>
        <div className="flex w-full gap-2 mt-8 sm:mt-10">
          <button
            className="bg-white rounded-[100px] border-2 border-blue-800 text-center flex shadow w-1/2"
            onClick={onSkip}
          >
            <div className="text-blue-800  font-semibold font-['SF Pro Display'] flex justify-center items-center  px-4 py-3 w-full">
              Skip
            </div>
          </button>
          <button
            className="bg-blue-800 rounded-[100px] text-center flex shadow hover:bg-blue-800/90  w-1/2"
            type="submit"
          >
            <div className="text-white  font-semibold font-['SF Pro Display']  flex justify-center items-center px-4 py-3 w-full">
              Next
            </div>
          </button>
        </div>
      </form>
    </div>
  );
};

export default VitalForm1;
